import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15, delayChildren: 0.3 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: {
      opacity: 1, y: 0,
      transition: { type: 'spring', stiffness: 100, damping: 12 }
    }
  };

  const services = [
    "AI Platform Engineering",
    "NLP Systems Development",
    "Language Technology Solutions",
    "Dataset Engineering",
    "Speech AI Systems",
    "Backend Architecture",
  ];

  return (
    <footer className="bg-slate-950 text-white py-16 border-t border-slate-800/50">
      <div className="section-container">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-3 gap-10"
        >
          <motion.div variants={itemVariants}>
            <h3 className="text-lg font-bold mb-6">
              <span className="text-white">Obert</span>
              <span className="gradient-text"> Manyasa</span>
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              AI Engineer and NLP Engineer building production-grade AI infrastructure for African languages.
            </p>
            <div className="space-y-3">
              <motion.a
                href="mailto:omanyasa@yahoo.com"
                className="flex items-center gap-3 text-sm text-slate-400 hover:text-cyan-300 transition-colors"
                whileHover={{ x: 4 }}
              >
                <FaEnvelope className="w-4 h-4" />
                omanyasa@yahoo.com
              </motion.a>
              <motion.a
                href="https://github.com/wealthymanyasa"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-slate-400 hover:text-cyan-300 transition-colors"
                whileHover={{ x: 4 }}
              >
                <FaGithub className="w-4 h-4" />
                GitHub
              </motion.a>
              <motion.a
                href="https://www.linkedin.com/in/obertmanyasa"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-slate-400 hover:text-cyan-300 transition-colors"
                whileHover={{ x: 4 }}
              >
                <FaLinkedin className="w-4 h-4" />
                LinkedIn
              </motion.a>
            </div>
          </motion.div>

          <motion.div variants={itemVariants}>
            <h3 className="text-sm font-semibold text-white mb-5 font-mono tracking-wider">
              Services
            </h3>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <span className="text-sm text-slate-400">{s}</span>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div variants={itemVariants}>
            <h3 className="text-sm font-semibold text-white mb-5 font-mono tracking-wider">
              Focus
            </h3>
            <ul className="space-y-3">
              <li><span className="text-sm text-slate-400">African Language AI</span></li>
              <li><span className="text-sm text-slate-400">Natural Language Processing</span></li>
              <li><span className="text-sm text-slate-400">Speech Technologies</span></li>
              <li><span className="text-sm text-slate-400">Machine Translation</span></li>
              <li><span className="text-sm text-slate-400">Language Resources</span></li>
              <li><span className="text-sm text-slate-400">AI Infrastructure</span></li>
            </ul>
          </motion.div>
        </motion.div>

        <motion.div
          variants={itemVariants}
          className="mt-12 pt-8 border-t border-slate-800/50 flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <p className="text-sm text-slate-500">
            &copy; {new Date().getFullYear()} Obert Manyasa. Built with React & Tailwind CSS.
          </p>
          <div className="flex space-x-4">
            <motion.a
              href="https://github.com/wealthymanyasa"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.2, color: "#06b6d4" }}
              className="text-slate-500 hover:text-cyan-400 transition-colors"
            >
              <FaGithub className="w-5 h-5" />
            </motion.a>
            <motion.a
              href="https://www.linkedin.com/in/obertmanyasa"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.2, color: "#06b6d4" }}
              className="text-slate-500 hover:text-cyan-400 transition-colors"
            >
              <FaLinkedin className="w-5 h-5" />
            </motion.a>
            <motion.a
              href="mailto:omanyasa@yahoo.com"
              whileHover={{ scale: 1.2, color: "#06b6d4" }}
              className="text-slate-500 hover:text-cyan-400 transition-colors"
            >
              <FaEnvelope className="w-5 h-5" />
            </motion.a>
            <motion.a
              href="https://x.com/ManyasaObert"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.2, color: "#06b6d4" }}
              className="text-slate-500 hover:text-cyan-400 transition-colors"
            >
              <FaTwitter className="w-5 h-5" />
            </motion.a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
